export default __webpack_public_path__ + "static/media/arrow_up.3fea74a3.svg";